<template>
    <div>
        <header role="heading">
            <h1>Profile</h1>
        </header>
        <div v-if="profileHasLoaded == 1">
            <div class="row">
                <div class="student-info col-12 col-md-5 card m-3">
                    <section id="personalInfo" class="clearfix p-3">
                        <h2><a id="personalanchor" name="personalanchor"></a>Student Information</h2>
                        <p>
                            <strong>Preferred Name: </strong>{{preferredName}}<br />
                            <strong>First Name: </strong>{{firstName}}<br />
                            <strong>Last Name: </strong> {{lastName}}
                        </p>
                        <p>
                            <strong>Mailing Address: </strong><br />
                            {{street1}}<br />
                            <span v-if="notNullOrEmpty(street2)">
                                {{street2}}<br />
                            </span>
                            <span v-if="notNullOrEmpty(street3)">
                                {{street3}}<br />
                            </span>
                            {{city}}
                            <span v-if="notNullOrEmpty(state)">
                                , {{state}} {{postalCode}} <br />
                            </span>
                            {{nation}}
                        </p>
                        <p><a :href="selfServiceProfilePath" target="_blank" class="btn btn-primary">Update</a></p>
                    </section>
                </div><!--/.col-->
                <div class="emergency-info col-12 col-md-5 card m-3">
                    <section id="eContact" class="clearfix p-3">
                        <h2><a id="eContactAnchor" name="eContactAnchor"></a>Emergency Contacts</h2>
                        <div v-if="notNullOrEmpty(emergencyContactList)">
                            <p v-for="(contact, index) in emergencyContactList" :key="index">
                                    {{contact.emergencyContactName}}
                                    
                                    <span v-if="notNullOrEmpty(contact.emergencyContactRelationship)">
                                        - {{contact.emergencyContactRelationship}}<br />
                                    </span>
                                    <span v-if="notNullOrEmpty(contact.emergencyContactPhone)">
                                        {{contact.emergencyContactPhone}}<br />
                                    </span>
                                    <span v-if="notNullOrEmpty(contact.emergencyContactStreet1)">
                                        {{contact.emergencyContactStreet1}} <br />
                                    </span>
                                    <span v-if="notNullOrEmpty(contact.emergencyContactCity)">
                                        {{contact.emergencyContactCity}}
                                        <span v-if="notNullOrEmpty(contact.emergencyContactState)">
                                            , {{contact.emergencyContactState}} {{contact.emergencyContactPostalCode}} <br />
                                        </span>
                                        {{contact.emergencyContactNation}}
                                    </span>
                            </p>
                            
                        </div>
                        <div v-else>
                            <p>No emergency contacts on file</p>
                        </div>
                        <p><a :href="selfServiceProfilePath" target="_blank" class="btn btn-primary">Update</a></p>
                    </section>
                </div><!--/.col-->
                
            </div><!--/.row-->
            <div class="row">
                <div class="col-12 col-md-5 m-3 card">
                    <DocUpload></DocUpload>
                </div>

            </div>
        </div>
        <div v-else>
            <div v-if="profileHasLoaded == 2">
                <p>We are having trouble loading this page. This could be because we can't find a record for you or we are having connectivity problems.</p>
            </div>
            <div v-else>
                <spinner></spinner>
            </div>
        </div>
    </div>
</template>

<script>
    import spinner from "../components/spinner.vue";
    import DocUpload from "../components/DocUpload.vue";
    import { getSelfServiceProfileUrl } from "@/common/envMixins";

export default {
     name: 'Profile',
     components: {
         spinner,
         DocUpload
     },
     //these are all placeholders until we start getting state from the api
     computed: {
         profileHasLoaded() { return this.$store.state.profileInfoIsLoaded },
         selfServiceProfilePath() {return getSelfServiceProfileUrl()},
         preferredName() { return this.$store.state.studentProfileInfo.preferredName },
         firstName() { return this.$store.state.studentProfileInfo.firstName },
         lastName() { return this.$store.state.studentProfileInfo.lastName },
         street1() { return this.$store.state.studentProfileInfo.street1 },
         street2() { return this.$store.state.studentProfileInfo.street2 }, 
         street3() { return this.$store.state.studentProfileInfo.street3},
         state() { return this.$store.state.studentProfileInfo.state},
         city() { return this.$store.state.studentProfileInfo.city},
         postalCode() {return this.$store.state.studentProfileInfo.postalCode},
         nation() { return this.$store.state.studentProfileInfo.nation }, 
         emergencyContactList() { return this.$store.state.studentProfileInfo.emergencyContactList;}
     },
     mounted() {
        if (this.$store.state.profileInfoIsLoaded == 0) {
            this.$store.dispatch("getStudentProfileInfo");
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
